define(function (require) {
	const tpl = require('./templates/t_itv_date_time_field.hbs');
	const baseElement = require('./v_itv_base_element');
	const utils = require('civicsUtils/general_utilities');
	return baseElement.extend({
		template: tpl,
		getData: function () {
			var data = {};
			var val = this.getValue();
			data[this.name] = val;

			return data;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			//for date time we have to manually grab the two components and piece it together.
			if (!_.isEmpty(this.model.get('format')) && this.model.get('format').toLowerCase() == 'dateandtime') {
				let dateVal = this.$el.find('input[data-formattype="date"]').val();
				let timeVal = this.$el.find('input[data-formattype="time"]').val();
				let val = utils.civicsDateTimeString(dateVal, timeVal, true);

				return val;
			}
			//for time fields, retain the format and just return it.
			var val = this.$el.find('input').val();
			// for date fields, we convert to date format along with the moment then convert to ISO string in the utils
			if(!_.isEmpty(val) && !_.isEmpty(this.model.get('format')) && this.model.get('format').toLowerCase() == 'date'){
				let dt = new Date(utils.createMoment(this.$el.find('input').val()));

           		val = utils.civicsDateTimeString(dt, '', true);
			} 

			return val;
		},
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			//format can be Date / Time / DateAndTime. we need date/time/datetime.
			var pickerFormat = !_.isEmpty(self.model.get('format')) ?self.model.get('format').toLowerCase().replace('and','') : '';

			var ret = {
				classes:function(){
					var classes = 'date-field-container ';
					if(self.model.get('isVisible') === false){
						classes+='hidden ';
					}
					if(pickerFormat == 'datetime'){
						classes += 'wider-column ';
					}
					return classes;
				},
				customAttr:function(){
					var attrs = self.model.get('customAttr');
					attrs+='data-dataType="' + self.model.get('dataType') + '" ';
					if(self.model.get('rangeMinValid')){
						attrs += 'data-minVal="'+self.model.get('rangeMinValid')+'" ';
					}
					if(self.model.get('rangeMaxValid')){
						attrs += 'data-maxVal="'+self.model.get('rangeMaxValid')+'" ';
					}
					if(self.config.isInGrid){
						attrs += 'specialType="grid" ';
					}
					return attrs;
				},
				pickerFormat:pickerFormat,
				value:function(){
					var val;
					if(self.config.readOnlyForm){
						
						if(pickerFormat == 'datetime'){
							val = Handlebars.helpers['global:formatDateTime'](self.model.get('value'));
						} else if (pickerFormat == 'time'){
							val = Handlebars.helpers['global:formatTime'](self.model.get('value'));
						} else if(pickerFormat == 'date'){
							val = Handlebars.helpers['global:formatDate'](self.model.get('value'));
						}
					} else {
						val = self.model.get('value');
					}
					return val;
				}()
			};

			ret = $.extend({},baseTH,ret);
			return ret;
		}
	});
});